import React from 'react';
import { Chip, Typography, Divider, ListItemText, ListItem, List } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AssignmentTurnedIn } from '@mui/icons-material';
import { formatAs, getAsStartAndEndTimeFormat, formatDateRange, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { PartialIcon } from '../core';
import { ShiftSegmentTypeName } from '../../../Enums';
import './SegmentList.scss';

const TooltipListItemText = styled(ListItemText)({
    '& .MuiListItemText-primary': {
        fontSize: '14px',
        fontWeight: '500',
    },
});

const TooltipListItem = styled(ListItem)({
    padding: '2px 14px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: '0px',
});

export default function SegmentList(props) {

    const getShiftSegmentType = (type) => {
        switch (type) {
            case ShiftSegmentTypeName.TRANSFER_SEGMENT:
                return "Transfer (X)";
                break;
            case ShiftSegmentTypeName.BREAK_SEGMENT:
                return "Break";
                break;
            case ShiftSegmentTypeName.REGULAR_SEGMENT:
                return "Regular";
                break;
            default:
                return ""
                break;
        }
    }

    return (
        <List style={{ minWidth: '310px' }}>
            <ListItem>
                <>
                    {props.isVto
                        ? (<Chip size="small" className="segment-chip-vto" label="VTO" />)
                        : props.isOpenShift
                            ? (<Chip size="small" className="segment-chip-open-shift" label="Open Shift" />)
                            : (<Chip size="small" className="segment-chip" label="Shift" />)
                    }
                    {props.isSignUp && <AssignmentTurnedIn className="signUpIconSize"/>}
                    {props.isPartial && <PartialIcon />}
                </>
            </ListItem>
            <TooltipListItem >
                <Typography className="segment-header-secondary">
                    {`(${formatAs(props.data.startDateTime, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)})`}
                </Typography>
            </TooltipListItem>
            <TooltipListItem >
                <Typography className="segment-header-primary">{getAsStartAndEndTimeFormat(props.data.startDateTime, props.data.endDateTime)}</Typography>
            </TooltipListItem>
            {props.data.assignmentName && (
                <TooltipListItem>
                    <Typography className="segment-header-secondary">{`Assignment: ${props.data.assignmentName}`}</Typography>
                </TooltipListItem>
            )}
            {props.selectedAssignmentName && (
                <TooltipListItem>
                    <Typography className="segment-header-secondary">{`Selected assignment: ${props.selectedAssignmentName}`}</Typography>
                </TooltipListItem>
            )}
            <Divider />
            {props.data.segments?.map((item, index) => (
                <TooltipListItem key={`segment-tooltip-list-item-${item.id}`}>
                    <TooltipListItemText
                        primary={
                            <React.Fragment><span className="segment-number">{index + 1}</span>
                                {
                                    `${getAsStartAndEndTimeFormat(item.startDateTime, item.endDateTime)} ${getShiftSegmentType(item.type)}`
                                }
                            </React.Fragment>
                        }
                    />
                    {
                        (item.orgJobRef) && (
                            <TooltipListItemText
                                secondary={item.orgJobRef.qualifier}
                            />
                        )
                    }
                    {
                        (item.costCenter) && (
                            <TooltipListItemText
                                secondary={item.costCenter.costCenter.qualifier}
                            />
                        )
                    }
                    {
                        (item.workruleRef  && item.workruleRef?.qualifier !== item.primaryWorkruleRef?.qualifier) && (
                            <TooltipListItemText
                                secondary={item.workruleRef.qualifier}
                            />
                        )
                    }
                </TooltipListItem>
            )
            )}
        </List>
    )
}